export default __webpack_public_path__ + "static/media/Cinefile.ce0e695f.png";